<lib-button-primary
  class="d-flex justify-content-between align-items-center"
  [iconSrc]="'assets/icons/light/Plus.svg'"
  (buttonClicked)="buttonClicked.emit()"
  i18n>
  Create Submission
</lib-button-primary>
